<template>
    <div :class="preCls + 'content-box'">
        <div :class="preCls + 'filter'" style="margin-bottom: 20px">
            <filter-date-range
                :startDate.sync="filter.startDate"
                :endDate.sync="filter.endDate"
                @on-change="search"
            ></filter-date-range>
        </div>
        <table-tool-bar>
            <template slot="left"></template>
            <Button
                v-if="$can('add')"
                :class="preCls + 'button-margin'"
                :disabled="loading"
                type="primary"
                @click="onClickAdd"
            >
                新增资讯
            </Button>
        </table-tool-bar>
        <Table
            ref="mt"
            :columns="columns"
            :data="page.list"
            :loading="loading"
            :height="mtHeight"
        >
            <template #publishStatus="{ row }">
                <i-switch
                    v-model="row.publishStatus"
                    true-value="1"
                    false-value="0"
                    @on-change="onPublishStatusChange(row, $event)"
                ></i-switch>
            </template>
            <!-- 操作列 -->
            <template v-slot:action="{ row }">
                <Button
                    :disabled="loading"
                    type="default"
                    size="small"
                    style="margin-right: 5px"
                    @click="showInfo(row)"
                    >详情</Button
                >
                <PoptipButton
                    v-if="row.publishStatus != '1' && $can('delete')"
                    :disabled="loading"
                    text="删除"
                    transfer
                    type="default"
                    title="您确定删除这条记录吗？"
                    :ok="
                        () => {
                            rowConfirmDelete(row)
                        }
                    "
                >
                </PoptipButton>
            </template>
        </Table>
        <!-- 底部分页 -->
        <table-pager
            :total.sync="page.total"
            :pageSize.sync="filter.pageSize"
            :pageNo.sync="filter.pageNo"
            @change="fetch"
        >
        </table-pager>
        <!-- 弹出层 -->
        <smart-modal
            v-model="modal.showInformation"
            :title="curId ? '资讯编辑' : '资讯登记'"
            :width="800"
            :height="560"
            :maskClosable="false"
            :buttons.sync="formBtns"
            @close-by-confirm="search"
        >
            <i-notice-form v-if="modal.showInformation" :id="curId">
            </i-notice-form>
        </smart-modal>
    </div>
</template>
<script>
import Dict from '_u/dict'
import { mapCache } from '@/plugins/vux-data-cache'
import { mapCell, pipeCell } from '_c/grid/renderCell'
import { notifyList, notifyDelete, notifyPublish } from '@/api/notify'
import iNoticeForm from './i-notice-form'
import FilterDateRange from '_v/components/filter/filter-date-range'

export default {
    name: 'iNoticeList',

    components: {
        iNoticeForm,
        FilterDateRange,
    },

    data() {
        return {
            mtHeight: 360,
            loading: false,
            page: {
                total: 0,
                list: [],
            },
            dict: {
                publicNotifyType: Dict.NULL,
            },
            modal: {
                showInformation: false,
            },
            curId: '',
            formBtns: [],
        }
    },

    computed: {
        ...mapCache({
            filter: 'infoFilter',
        }),
        columns() {
            return [
                {
                    type: 'index',
                    title: '序号',
                    align: 'center',
                    width: 60,
                },
                {
                    key: 'title',
                    title: '资讯标题',
                    align: 'left',
                    minWidth: 140,
                },
                {
                    key: 'floorName',
                    title: '楼栋',
                    align: 'left',
                    minWidth: 160,
                    tooltip: true,
                },
                {
                    key: 'notifyType',
                    title: '资讯类别',
                    align: 'center',
                    width: 100,
                    render: mapCell(this.dict.publicNotifyType.val()),
                },
                {
                    key: 'publishTime',
                    title: '发布时间',
                    align: 'left',
                    width: 160,
                    render: pipeCell('ymdL'),
                },
                {
                    key: 'publisher',
                    title: '发布人',
                    align: 'left',
                    minWidth: 80,
                },
                {
                    key: 'publishStatus',
                    title: '是否发布',
                    align: 'center',
                    width: 100,
                    slot: 'publishStatus',
                },
                {
                    key: 'action',
                    title: '操作',
                    align: 'center',
                    width: 200,
                    fixed: 'right',
                    slot: 'action',
                },
            ]
        },
    },

    created() {
        this.fetch()
    },

    mounted() {
        this.afterContainerResize((el, detector) => {
            this.mtHeight =
                detector.windowHeight -
                this.$refs.mt.$el.getBoundingClientRect().top -
                80
        })
    },

    methods: {
        fetch() {
            this.loading = true

            return Promise.all([
                Dict.get(['public_notify_type']),
                notifyList(this.filter),
            ])
                .then((args) => {
                    var [dictGroup, page] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })

                    this.setPageData(page.data)
                })
                .finally(() => {
                    this.loading = false
                })
        },

        search() {
            this.filter.pageNo = 1
            this.fetch()
        },

        setPageData(data) {
            this.page.list = data.page.list
            this.page.total = parseInt(data.page.totalCount)
        },

        onClickAdd(e) {
            this.curId = ''
            this.modal.showInformation = true
        },

        onPublishStatusChange(row) {
            notifyPublish(row.id)
                .then(() => {
                    this.$Message.success(this.$t('tips.update.success'))
                })
                .then(() => this.fetch())
        },

        showInfo(row) {
            this.curId = row.id
            this.modal.showInformation = true
        },

        rowConfirmDelete(row) {
            this.loading = true

            notifyDelete(row.id)
                .then((res) => {
                    this.$Message.success(this.$t('tips.delete.success'))
                })
                .then(() => this.fetch())
                .finally(() => (this.loading = false))
        },
    },
}
</script>
<style lang="less" scoped></style>
